import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "upload-modal__inner" }
const _hoisted_2 = { class: "upload-modal__title-heading" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Project ", -1 /* HOISTED */)
const _hoisted_4 = { class: "upload-modal__title" }
const _hoisted_5 = { class: "upload-modal__content" }
const _hoisted_6 = {
  key: 0,
  class: "upload-modal__complete-message"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " This project is now complete and further uploading has been disabled. ", -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "upload-modal__complete-message"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " Your files are being processed and will be available to view shortly. ", -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " Remember that uploads need to be approved by a PM or Lead Artist before they are visible to clients. ", -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "upload-modal__files" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Thumbnail"),
    /*#__PURE__*/_createElementVNode("th", null, "Asset"),
    /*#__PURE__*/_createElementVNode("th", null, "Tour URL"),
    /*#__PURE__*/_createElementVNode("th", null, "Stage"),
    /*#__PURE__*/_createElementVNode("th", null, "Artist"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1 /* HOISTED */)
const _hoisted_15 = { colspan: "5" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "upload-modal__submit-bar" }
const _hoisted_18 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ExploreUploadRowComponent = _resolveComponent("ExploreUploadRowComponent")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Modal header "),
    _createElementVNode("div", {
      class: _normalizeClass(["upload-modal__header", { 'upload-modal__header--less-padding': $props.formatLocked }])
    }, [
      (!$props.formatLocked)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "upload-modal__back",
            "aria-label": "Go back",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit( 'back-to-format-select' )))
          }, " Back "))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("h2", _hoisted_4, _toDisplayString($props.project.title), 1 /* TEXT */)
      ])
    ], 2 /* CLASS */),
    _createCommentVNode(" Modal content "),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($props.project.project_status === 'completed' || $props.project.project_status === 'terminated')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : ($data.show_complete_message)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
              : (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  id: "image-upload",
                  class: _normalizeClass(["upload-modal__drag-drop flex", { 'upload-modal__drag-drop--hover': $data.hover }])
                }, [
                  _createElementVNode("table", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.entries, (id, index) => {
                        return (_openBlock(), _createBlock(_component_ExploreUploadRowComponent, {
                          id: id,
                          ref_for: true,
                          ref: id,
                          key: id,
                          project: $props.project,
                          asset: $props.asset,
                          stage: $props.stage,
                          "assets-list": $options.assets_list,
                          "staff-list": $options.project_staff_list,
                          "can-remove": index > 0,
                          "upload-id": $data.upload_id,
                          entries: $data.entries,
                          "artist-id": $data.copied_artist_id,
                          onRemoveRow: $event => ($options.removeExplore( index )),
                          onValidityChecked: valid => $options.validateEntry( id, valid ),
                          onUploadCompleted: $event => ($options.finishEntryUpload( id )),
                          onUploadFailed: $event => ($options.handleUploadFailure( id )),
                          onCopyArtistToAll: $options.copyArtistToAll
                        }, null, 8 /* PROPS */, ["id", "project", "asset", "stage", "assets-list", "staff-list", "can-remove", "upload-id", "entries", "artist-id", "onRemoveRow", "onValidityChecked", "onUploadCompleted", "onUploadFailed", "onCopyArtistToAll"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_15, [
                        _createElementVNode("button", {
                          class: "button button--fill mt-16",
                          disabled: !$options.awaiting_upload,
                          onClick: _cache[1] || (_cache[1] = (...args) => ($options.addExplore && $options.addExplore(...args)))
                        }, " Add explore ", 8 /* PROPS */, _hoisted_16)
                      ])
                    ])
                  ])
                ], 2 /* CLASS */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createCommentVNode(" Modal submit bar "),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("button", {
        class: _normalizeClass(["button button--fill", { 'button--loading': $options.upload_in_progress }]),
        disabled: !$options.awaiting_upload,
        onClick: _cache[2] || (_cache[2] = (...args) => ($options.checkValidity && $options.checkValidity(...args)))
      }, " Upload ", 10 /* CLASS, PROPS */, _hoisted_18)
    ])
  ]))
}